module.exports = __webpack_public_path__ + "img/logoEstado.e7b9e51b.svg";